import request from './plugins/request'

// 修改密码
export let changePassword = (params = {}) => {
    return request({
        url: '/account/password',
        params: params,
        method: 'put'
    })
}
